import { render, staticRenderFns } from "./MyChallenges.vue?vue&type=template&id=2de0c792&scoped=true&"
import script from "./MyChallenges.vue?vue&type=script&lang=js&"
export * from "./MyChallenges.vue?vue&type=script&lang=js&"
import style0 from "./MyChallenges.vue?vue&type=style&index=0&id=2de0c792&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de0c792",
  null
  
)

export default component.exports